import { GET_TRANSFERS_SUCCESS } from "./transfer.types";

const initialState = {
  transfers: null,
};

export const transferReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_TRANSFERS_SUCCESS:
      return {
        ...state,
        transfers: action.payload,
      };

    default:
      return state;
  }
};
